import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-client-testimonial',
  templateUrl: './client-testimonial.component.html',
  styleUrls: ['./client-testimonial.component.scss']
})
export class ClientTestimonialComponent implements OnInit {

  
  testimonialArray: any;
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    nav: false,
    dots: true,
    autoplay: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 2
      },
      940: {
        items: 2
      }
    },
    
  }
  
  constructor() { }

  ngOnInit(): void {
    this.initialize();
  }
  initialize() {
    this.testimonialArray = {
      "clientList": [{
        "img" : "assets/img/client-1.png",
        "company" : "Mahindra Trucks",
        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s",
        "name":"Alexa Zender",
        "designation":"CEO Mahindra Trucks"
      },
      {
        "img" : "assets/img/client-2.png",
        "company" : "Tata Motors",
        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s",
        "name":"Harvy Spectorr",
        "designation":"Principal Director"
      },
      {
        "img" : "assets/img/client-1.png",
        "company" : "Mahindra Trucks",
        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s",
        "name":"Alexa Zender",
        "designation":"CEO Mahindra Trucks"
      }
      ]
    }
  }

}
